import React, { Component } from 'react'

class InformationIcon extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  getStyle() {
    const { hover } = this.state
    const { color = '#3fa6c1', hoverColor = '#77d8f4' } = this.props
    const buttonColor = hover ? hoverColor : color
    return {
      border: '2px solid',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 20,
      width: 20,
      borderRadius: 13,
      color: buttonColor,
      borderColor: buttonColor,
      fontSize: 16
    }
  }

  render() {
    const { onClick } = this.props
    return (
      <a
        style={this.getStyle()}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
      >
        ?
      </a>
    )
  }
}

export { InformationIcon }



// WEBPACK FOOTER //
// ./src/components/common/InformationIcon.js